import { render } from "./WatchlistIndex.vue?vue&type=template&id=02d2db42&ts=true"
import script from "./WatchlistIndex.vue?vue&type=script&lang=ts"
export * from "./WatchlistIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__